import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
            帮助中心
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {faqData.title}
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3">
          {faqData.items.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg p-5">
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                <span className="text-primary-500 mr-2">Q{idx + 1}.</span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}